import type { Boss, Player } from './types'
import { awokenBiteInPocket, awokenBiteMinReachPx } from './awoken_bite_mouth'

let enabled = true
// Idle front-paw offset: (bbox center 720.5 - paw 359.5) * displayHeight 186 / refH 850.
// All three spin anchors preserve this facing-local offset (geometry tests pin it).
export const AWOKEN_SPIN_FRONT_PAW_OFFSET_PX = 361 * 186 / 850
export function setAwokenPocketSpinEnabled(value: boolean): void { enabled = value }
export function awokenPocketOrBehind(boss: Boss, player: Pick<Player, 'x'>): boolean {
  const dir = boss.facing === 'right' ? 1 : -1
  return awokenBiteInPocket(boss, player, 'feralBite') || (player.x - boss.x) * dir <= -24
}
export function shouldChainAwokenPocketSpin(boss: Boss, player: Player): boolean {
  const atk = boss.currentAttack
  return enabled && boss.id === 'crowned-king-awoken' && boss.hp > 0
    && player.state !== 'executing' && !!atk && !atk.playerLethal && !atk.bossFinisher
    && awokenBiteMinReachPx(atk.id) !== undefined && !boss.attackConnected
    && awokenPocketOrBehind(boss, player) && (boss.awokenSpinStreak ?? 0) < 2
}
